import React from "react";

export const formGroupSegmen = {
    id: {value: ""},
    segmentName: {value: "", mandatory: true},
    status: {value: "ACTIVE"},
};

export const formGroupSubSegmen = {
    id: {value: ""},
    idSegment: {value: {}, mandatory: true},
    subSegmentName: {value: "", mandatory: true},
    status: {value: "ACTIVE"},
};

export const formGroupSeries = {
    id: {value: ""},
    idSubSegment: {value: {}, mandatory: true},
    seriesName: {value: "", mandatory: true},
    status: {value: "ACTIVE"},
};

export const formGroupType = {
    id: {value: ""},
    idSeries: {value: {}, mandatory: true},
    typeName: {value: "", mandatory: true},
    status: {value: "ACTIVE"},
};

export const formGroupVarian = {
    kodeVariant: {value: "", mandatory: true},
    kodeUnitPabrik: {value: "", mandatory: true},
    namaVariant: {value: "", mandatory: true},
    isiSilinder: {value: "", mandatory: true},
    digitAwalNosin: {value: "", mandatory: true},
    digitAwalNoka: {value: "", mandatory: true},
    idType: {value: {}, mandatory: true},
    discontinue: {value: {}, mandatory: true},
    status: {value: "ACTIVE"},
};

export const formGroupWarna = {
    id: {value: ""},
    kodeWarna: {value: ""},
    namaWarnaPabrik: {value: ""},
    namaWarnaKomersil: {value: ""},
    kodeVariant: {value: {}, mandatory: true},
    discontinue: {value: {}},
};

export const tableConfig = {
    segmen: [
        {
            name: "segmentName",
            label: "Segmen",
            options: {
                sort: false,
            },
        },
    ],
    subsegmen: [
        {
            name: "segmentName",
            label: "Segmen",
            options: {
                sort: false,
            },
        },
        {
            name: "subSegmentName",
            label: "Sub Segmen",
            options: {
                sort: false,
            },
        },
    ],
    series: [
        {
            name: "segmentName",
            label: "Segmen",
            options: {
                sort: false,
            },
        },
        {
            name: "subSegmentName",
            label: "Sub Segmen",
            options: {
                sort: false,
            },
        },
        {
            name: "seriesName",
            label: "Series",
            options: {
                sort: false,
            },
        },
    ],
    type: [
        {
            name: "seriesName",
            label: "Series",
            options: {
                sort: false,
            },
        },
        {
            name: "typeName",
            label: "Tipe",
            options: {
                sort: false,
            },
        },
    ],
    varian: [
        {
            name: "kodeVariant",
            label: "Kode Varian",
            options: {
                sort: false,
            },
        },
        {
            name: "kodeUnitPabrik",
            label: "Kode Unit Pabrik",
            options: {
                sort: false,
            },
        },
        {
            name: "namaVariant",
            label: "Nama Varian",
            options: {
                sort: false,
            },
        },
        {
            name: "isiSilinder",
            label: "Isi Silinder",
            options: {
                sort: false,
            },
        },
        {
            name: "digitAwalNosin",
            label: "Digit Awal Nosin",
            options: {
                sort: false,
            },
        },
        {
            name: "digitAwalNoka",
            label: "Digit Awal Noka",
            options: {
                sort: false,
            },
        },
        {
            name: "typeName",
            label: "Nama Tipe",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "discontinue",
            label: "Discontinue",
            options: {
                customBodyRender: (val) => <p>{val ? "YES" : "NO"}</p>,
                sort: false,
            },
        },
    ],
    warna: [
        {
            name: "id",
            label: "ID Warna",
            options: {
                sort: false,
            },
        },
        {
            name: "kodeWarna",
            label: "Kode Warna",
            options: {
                sort: false,
            },
        },
        {
            name: "namaWarnaPabrik",
            label: "Nama Warna Pabrik",
            options: {
                sort: false,
            },
        },
        {
            name: "namaWarnaKomersil",
            label: "Nama Warna Komersil",
            options: {
                sort: false,
            },
        },
        {
            name: "kodeVariant",
            label: "Kode Varian",
            options: {
                customBodyRender: (val) => <p>{val}</p>,
                sort: false,
            },
        },
        {
            name: "discontinue",
            label: "Discontinue",
            options: {
                customBodyRender: (val) => <p>{val ? "YES" : "NO"}</p>,
                sort: false,
            },
        },
    ],
};
